import Box from '@material-ui/core/Box';
import classNames from 'classnames';
import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';

export type NavigationMenuProps = {
	route: types.routes.ISingleDashboardRoute;
	// eslint-disable-next-line no-unused-vars
	toggleMenu: (i: number) => void;
	index: number;
	pathname: string;
	openMenu: number | null;
	parentName?: string;
	handleRouteClick: (navigationType: string, routeName: string, parentName?: string) => void;
};

const NavigationMenu = ({
	route,
	toggleMenu,
	index,
	pathname,
	openMenu,
	parentName,
	handleRouteClick,
}: NavigationMenuProps) => {
	const routePath: string = route.customPath ?? route.layout + route.path;

	const collapseActive: boolean = useMemo(() => {
		let ifRouteActive = false;
		if (route.collapse && route.views && route.views.length > 0) {
			ifRouteActive = route.views.some(
				(singleRoute) => pathname.indexOf(`${singleRoute.layout}${singleRoute.path}`) !== -1
			);
		}
		return ifRouteActive;
	}, [pathname, route]);

	const icon = route.icon ? (
		<Box component="span" display={{ xs: 'inline', lg: 'none' }} className="icon">
			<img src={`/${route.icon}.svg`} alt="" aria-hidden="true" />
		</Box>
	) : (
		<></>
	);

	const handleClick = (
		navigationType: string,
		routeName: string,
		parentName?: string,
		event?: React.MouseEvent<HTMLAnchorElement>
	) => {
		if (route.customPath) {
			event?.preventDefault();
			window.location.href = route.customPath;
		} else {
			handleRouteClick(navigationType, routeName, parentName);
			if (location.pathname === routePath) {
				location.href = routePath;
			}
		}
	};

	const openChildMenu = (e: any) => {
		if (e.key === 'Enter' || e.key === ' ') {
			e.preventDefault();
			toggleMenu(index);
		}
	};

	const parentItemClasses = classNames('nav-link has-child', {
		active: pathname === routePath || collapseActive,
		'active-parent': openMenu === index,
	});

	const childItemClasses = classNames('nav-link', {
		active: pathname === routePath,
	});

	return (
		<>
			{route.views?.length ? (
				<Box
					component="span"
					onKeyDown={openChildMenu}
					onClick={() => toggleMenu(index)}
					className={parentItemClasses}
					data-testid="parent-item"
					role="button"
					tabIndex={0}
					aria-haspopup="true"
					aria-expanded={openMenu === index}
					aria-controls={`submenu-${index}`}
				>
					{icon} {route.name}
				</Box>
			) : (
				<Link
					to={routePath}
					className={childItemClasses}
					onClick={(event: React.MouseEvent<HTMLAnchorElement>) =>
						handleClick('primary_navigation', route?.name, parentName, event)
					}
				>
					{icon} {route.name}
				</Link>
			)}
		</>
	);
};

export default NavigationMenu;
